const SurveyViewModel = {
  create(surveyData) {
    const parsedQuestions = surveyData.questions
      .filter(q => q.isActive)
      .sort((a, b) => a.sortOrder - b.sortOrder);

    const isSingleQuestionSurvey = parsedQuestions.length === 1;

    const questions = parsedQuestions
      .map(question => ({
        ...question,
        answer: null,
        options: question.options.filter(x => x.isActive),
        normalizedOptions: question.options.map(option => ({
          display: option.value,
          value: option.value
        }))
      }));

    const npsSurveyQuestion = questions.find(question => question.questionType === 'NetPromoterScore');

    const survey = {
      ...surveyData,
      isSingleQuestionSurvey,
      npsSurveyQuestion,
      questions
    };

    return survey;
  }
};

export default SurveyViewModel;
